import Grid from '@mui/material/Grid2';
import { makeStyles } from '@mui/styles';
import React, { useEffect, useState } from 'react';

import ButtonComponent from '#app/Component/ButtonComponent';
import DatePickerComponent from '#app/Component/DatePickerComponent';
import MultipleSelectComponent from '#app/Component/MultipleSelectComponent';
import ShadowBoxComponent from '#app/Component/ShadowBoxComponent';
import TitleComponent from '#app/Component/TitleComponent';
import { Form, initFormHandler } from '#app/Handler/FormHandler';
import { generateApiPath } from '#app/Handler/api';
import { momentDateFormatter } from '#app/Util/MomentDateFormatter';
import { Filters } from '#app/View/Accounting';
import OrderClientEntryPoints from '#app/entrypoints/orderClient';
import useShops from '#app/hooks/useShops';

type Props = {
  handleSearch: (data: Filters) => void;
  filters: Filters;
};

const Search: React.FC<Props> = ({ handleSearch, filters }) => {
  const classes = useStyles();
  const { shops } = useShops();
  const [loadingExport, setLoadingExport] = useState<boolean>(false);

  const [formSearch, setFormSearch] = useState<Form>({
    startDate: {
      name: 'startDate',
      label: 'Date de début',
      textHelper: 'Rechercher par date de début.',
      type: 'date',
      defaultValue: filters?.startDate,
    },
    endDate: {
      name: 'endDate',
      label: 'Date de fin',
      textHelper: 'Rechercher par date de fin.',
      type: 'date',
      defaultValue: filters?.endDate,
    },
    shops: {
      name: 'shops',
      label: 'Boutique',
      textHelper: 'Rechercher par boutique.',
      type: 'array',
      defaultValue: filters?.shops,
    },
  });

  const handlerFormSearch = initFormHandler(formSearch, setFormSearch);
  useEffect(() => {
    handlerFormSearch.start();
  }, []);

  const getData = (): Omit<Filters, 'page' | 'limit'> => {
    const data = handlerFormSearch.getData();
    return {
      startDate: momentDateFormatter.formatStartOfDay(data.startDate),
      endDate: momentDateFormatter.formatEndOfDay(data.endDate),
      shops: data.shops,
    };
  };

  const download = () => {
    setLoadingExport(true);

    const aElement = document.createElement('a');
    aElement.href = generateApiPath(OrderClientEntryPoints.getCollectionShopPaymentDownload, {}, getData());
    document.body.appendChild(aElement);
    aElement.click();
    document.body.removeChild(aElement);

    setTimeout(() => setLoadingExport(false), 10000);
  };

  return (
    <ShadowBoxComponent>
      <TitleComponent title="Filtres" />
      <Grid container spacing={1}>
        <Grid size={{ xs: 6, sm: 6, md: 6, lg: 3, xl: 3 }}>
          <DatePickerComponent id="startDate" handler={handlerFormSearch} />
        </Grid>
        <Grid size={{ xs: 6, sm: 6, md: 6, lg: 3, xl: 3 }}>
          <DatePickerComponent id="endDate" handler={handlerFormSearch} />
        </Grid>
        <Grid size={{ xs: 6, sm: 6, md: 6, lg: 3, xl: 3 }}>
          <MultipleSelectComponent withSelectAll id="shops" options={shops} handler={handlerFormSearch} />
        </Grid>
        <Grid size={{ xs: 6, sm: 6, md: 6, lg: 6, xl: 2 }}>
          <ButtonComponent className={classes.button} label="Rechercher" onClick={() => handleSearch(getData())} />
          <ButtonComponent
            className={classes.button}
            label="Télécharger"
            onClick={() => download()}
            disabled={loadingExport}
            loading={loadingExport}
          />
        </Grid>
      </Grid>
    </ShadowBoxComponent>
  );
};

const useStyles = makeStyles({
  button: {
    margin: '6px !important',
  },
});

export default Search;
